import { render } from "./VideoPlayerControlsSettingsVideoTrack.vue?vue&type=template&id=7ef173a6&scoped=true"
import script from "./VideoPlayerControlsSettingsVideoTrack.vue?vue&type=script&lang=js"
export * from "./VideoPlayerControlsSettingsVideoTrack.vue?vue&type=script&lang=js"

import "./VideoPlayerControlsSettingsVideoTrack.vue?vue&type=style&index=0&id=7ef173a6&scoped=true&lang=css"

import exportComponent from "/Users/sxdube/Documents/code/vue-viewer-plugin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ef173a6"]])

export default __exports__